import React, { Component } from 'react';
import BzmIcon from '../../../icons/BzmIcon';

type BlazePagerProps = {
  total: number;
  activePage: number;
  pageSelectedHandler: (pageNumber: number) => void;
};

/**
 * Blaze Pager
 *
 * <pre>
 *   Usage example:
 *   <code>
 *     <BlazePager total={transactions.length} activePage={1} pageSelectedHandler={fnCallback}/>
 *   </code>
 * </pre>
 */

class BlazePager extends Component<BlazePagerProps> {
  setCurrentPage = (activePageNo: number, e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e !== undefined) {
      e.preventDefault();
    }
    this.props.pageSelectedHandler(activePageNo);
  };

  prevPageClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    let currentPage = this.props.activePage;
    this.props.pageSelectedHandler(--currentPage);
  };

  nextPageClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    let currentPage = this.props.activePage;
    this.props.pageSelectedHandler(++currentPage);
  };

  render() {
    const { total, activePage } = this.props;

    const prevButtonDisabled = activePage === 1;
    const nextButtonDisabled = activePage === total;

    return (
      <nav aria-label="Pager">
        <ul className="pagination pagination-buttons">
          <li className="page-item">
            <button
              type="button"
              className="btn btn-secondary btn-circular"
              disabled={prevButtonDisabled}
              onClick={event => this.setCurrentPage(1, event)}
            >
              <BzmIcon variant={'icon-bzm-first'} className={'icon-xs'} />
              <span className="sr-only">First</span>
            </button>
          </li>
          <li className="page-item">
            <button
              type="button"
              className="btn btn-secondary btn-circular"
              disabled={prevButtonDisabled}
              onClick={event => this.prevPageClicked(event)}
            >
              <BzmIcon variant={'icon-bzm-chevron-left'} />
              <span className="sr-only">Previous</span>
            </button>
          </li>
          <li className="page-item page-item-current">
            <strong>{activePage}</strong> / {total}
          </li>
          <li className="page-item">
            <button
              type="button"
              className="btn btn-secondary btn-circular"
              disabled={nextButtonDisabled}
              onClick={event => this.nextPageClicked(event)}
            >
              <BzmIcon variant={'icon-bzm-chevron-right'} />
              <span className="sr-only">Next</span>
            </button>
          </li>
          <li className="page-item">
            <button
              type="button"
              className="btn btn-secondary btn-circular"
              disabled={nextButtonDisabled}
              onClick={event => this.setCurrentPage(total, event)}
            >
              <BzmIcon variant={'icon-bzm-last'} />
              <span className="sr-only">Last</span>
            </button>
          </li>
        </ul>
      </nav>
    );
  }
}

export default BlazePager;
